import { Dtos, SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../utils/request";
import { accountIndividualsQueryKey } from "./account.keys";

export const useFetchAccountIndividuals = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isLoading, refetch } = useQuery({
		queryKey: accountIndividualsQueryKey(accountId),
		queryFn: () =>
			get<Dtos.Individual.Get.Response[]>(`/v2/surety/accounts/${accountId}/individuals`),
	});

	return {
		individuals: data,
		individualsError: error,
		individualsIsLoading: isLoading,
		refetchAccountIndividuals: refetch,
	};
};
